import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import styled, { css } from "styled-components";
import { boxSelectionGlow } from "../../common/boxShadows";
import { keyboardFocus } from "../../common/keyboardFocus";
import { outlineBorderActiveBlueCSS, outlineBorderCSS } from "../../common/outlineActive";
import { DisplayCard } from "./DisplayCard";
const _NewCard = ({ children, active, disabled, padding, dataTestId, ...rest }) => {
    const ref = useRef(null);
    return (_jsx(Container, { tabIndex: 0, ...rest, ref: ref, padding: padding, "data-testid": dataTestId, "$active": active, "$disabled": disabled, children: children }));
};
export const SelectionCard = styled(_NewCard) ``;
const Container = styled(DisplayCard) `
  transition: all 0.2s ease-in-out;

  ${keyboardFocus};
  ${outlineBorderCSS};

  ${({ $disabled }) => !$disabled &&
    css `
      &:hover,
      &:focus {
        border-color: ${({ theme }) => theme.systemColors.grey400};
      }

      &:active {
        ${outlineBorderActiveBlueCSS};
        ${boxSelectionGlow}
      }

      &:focus-visible {
        border-color: ${({ theme }) => theme.systemColors.grey400};
      }
    `};

  ${({ $active }) => $active &&
    css `
      ${outlineBorderActiveBlueCSS};
      ${boxSelectionGlow}
    `};

  ${({ $disabled }) => $disabled &&
    css `
      background-color: ${(p) => p.theme.systemColors.grey200};
      cursor: not-allowed;

      & > * {
        opacity: 0.5;
      }
    `};
`;
